import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { useEditBackofficeCustomerMutation } from "modules/backoffice/hooks/customers/useEditBackofficeCustomerMutation"
import { useGetBackofficeCustomerQuery } from "modules/backoffice/hooks/customers/useGetBackofficeCustomerQuery"
import { Loading } from "modules/shared/components/Loading"
import { useTranslation } from "react-i18next"
import { UpsertBackofficeCustomerBodySchema } from "schema"
import { toast } from "sonner"
import { z } from "zod"
import { BackofficeCustomerForm } from "./BackofficeCustomerForm"

type BackofficeCustomerEditorProps = {
  customerId: string
  onOpenChange: () => void
}
export const BackofficeCustomerEditor = ({
  customerId,
  onOpenChange,
}: BackofficeCustomerEditorProps) => {
  const { t } = useTranslation()
  const { data: customer, isPending } = useGetBackofficeCustomerQuery({ query: { id: customerId } })
  const { mutateAsync } = useEditBackofficeCustomerMutation({ id: customerId })

  const onSubmit = async (data: z.input<typeof UpsertBackofficeCustomerBodySchema>) => {
    await mutateAsync(data)
    toast.success(t("backoffice.customers.editSuccess"))
    onOpenChange()
  }

  return (
    <Dialog onOpenChange={onOpenChange} open>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("backoffice.customers.edit.title")}</DialogTitle>
          <DialogDescription>{t("backoffice.customers.edit.description")}</DialogDescription>
        </DialogHeader>
        {isPending ? (
          <Loading />
        ) : (
          <BackofficeCustomerForm
            customer={customer}
            onSubmit={onSubmit}
            submitCopy={t("backoffice.customers.edit.save")}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}
